"use client";

import { useState, type ReactNode } from "react";

interface CheckListItemProps {
  text: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  trailing?: ReactNode;
}

export function CheckListItem({ text, checked: initialChecked, onChange, trailing }: CheckListItemProps) {
  const [checked, setChecked] = useState(initialChecked);

  const toggle = () => {
    const next = !checked;
    setChecked(next);
    onChange(next);
  };

  return (
    <button
      onClick={toggle}
      className="flex items-center gap-3 w-full py-2.5 text-left"
    >
      <div
        className={`w-[22px] h-[22px] rounded-md border-2 flex items-center justify-center transition-all ${
          checked
            ? "bg-[color:var(--accent-color)] border-[color:var(--accent-color)] scale-95"
            : "border-gray-300 dark:border-gray-600"
        }`}
      >
        {checked && (
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        )}
      </div>
      <span className={`flex-1 text-sm ${checked ? "line-through text-gray-400 dark:text-gray-500" : "text-gray-800 dark:text-gray-200"}`}>
        {text}
      </span>
      {trailing != null && <span className="ml-auto shrink-0">{trailing}</span>}
    </button>
  );
}
